 

const pageId = '251104';

export default {
  pageName: 'Weekly Report Configuration',
  pageId,
  pagePath: '/opinion/CustomizedReports/WeeklyReport/VersionPerformance/Configuration',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
};
